import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import Grid from '@mui/material/Grid2';
import { useNavigate } from "react-router-dom";
import { USER_LOGIN } from "../../constants/Constants";
import pepsicoLogo from "./../../assets/svgs/pepsiLogoHome.svg";
import styles from "./UserRegistration.module.css";
import EmailIcon from '@mui/icons-material/Email';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';

const textStyle = {
    font: 'normal normal 14px Segoe UI'
}

const UserRegistration = () => {

    const navigate = useNavigate();

    // const dispatch = useAppDispatch();

    // const [requestFormSent, setRequestFormSent] = useState(false);

    // const [isError, setIsError] = useState(false);

    // const [errorMessage, setErrorMessage] = useState('');

    // const [formValues, setFormValues] = useState<any>({
    //     email: '',
    //     firstName: '',
    //     lastName: '',
    //     activationCode: '',
    // });

    // const [errors, setErrors] = useState<any>({
    //     email: '',
    //     firstName: '',
    //     lastName: '',
    // });

    // const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    // const pepsicoDomainRegex = /^[A-Za-z0-9._%+-]+@pepsico\.com$/g;

    // const handleFormValueChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    //     const { name, value } = event.target;
    //     setFormValues({ ...formValues, [name]: value });
    // }

    const navigateToSignIn = () => {
        navigate(USER_LOGIN)
    }

    // const registerUser = () => {

    //     let formErrors = { firstName: '', email: '', lastName: '' };

    //     if (!formValues.firstName) {
    //         formErrors.firstName = "First name is required"
    //     }

    //     if (!formValues.lastName) {
    //         formErrors.lastName = "Last name is required"
    //     }

    //     if (!formValues.email) {
    //         formErrors.email = "Email is required"
    //     } else if (!emailRegex.test(formValues.email.toLowerCase())) {
    //         formErrors.email = "Email is not valid"
    //     } else if (pepsicoDomainRegex.test(formValues.email.toLowerCase())) {
    //         formErrors.email = "Please contact administrator for PepsiCo email";
    //     }

    //     if (Object.values(formErrors).some(error => error)) {
    //         setErrors(formErrors);
    //         return;
    //     }

    //     setErrors(formErrors);

    //     const reqPayload = {
    //         firstName: formValues.firstName,
    //         lastName: formValues.lastName,
    //         email: formValues.email
    //     }
    //     dispatch(startLoading());
    //     dispatch(registerExternalUser(reqPayload)).then((res: any) => {
    //         setRequestFormSent(true);
    //         if (res?.payload?.status !== 200) {
    //             setIsError(true);
    //             setErrorMessage(res?.payload?.message);
    //         }
    //         dispatch(stopLoading());
    //     }).catch((err: any) => {
    //         setRequestFormSent(true);
    //         setIsError(true);
    //         setErrorMessage("Something went wrong, Please try again later");
    //         console.log("Error in registering customers", err);
    //         dispatch(stopLoading());
    //     });
    // }

    return (
        <div className="backgroundImgHome">
            <Grid container className={styles.loginAppContainer}>
                <Grid size={{ xs: 1, sm: 1, md: 2, lg: 2.5, xl: 3 }}></Grid>
                <Grid size={{ xs: 10, sm: 10, md: 8, lg: 7, xl: 6 }}>
                    <Box className={styles.loginBoxContainer}>
                        <Grid container className={styles.loginForm} >
                            <Grid size={12} textAlign="center">
                                <span className={styles.imageLogo}>
                                    <img src={pepsicoLogo} alt='peplogo' />
                                </span>
                            </Grid>

                            <Grid size={12}>
                                <Grid container spacing={3}>
                                    <Grid size={12} textAlign={"center"}>

                                        <Typography sx={textStyle}>Almost There!</Typography>
                                    </Grid>
                                    <Grid size={12} textAlign={"center"}>
                                        <Typography sx={textStyle}>To complete your registration, kindly email the following details
                                            to our business team and ask for SpotFreight Access :</Typography>
                                    </Grid>
                                    <Grid size={12} textAlign={"center"}>
                                        <Typography sx={textStyle}>Name</Typography>
                                        <Typography sx={textStyle}>Surname</Typography>
                                        <Typography sx={textStyle}>Email Address</Typography>
                                    </Grid>
                                    <Grid size={12} textAlign={"center"}>
                                        <Box className={styles.scroll_container}>
                                            <TableContainer component={Paper}>
                                                <Table className={styles.tableCls} sx={{ minWidth: '800' }}>
                                                    <TableHead className={styles.tableHeader} key={"tableHeader"}>
                                                        <TableRow className={styles.tableHeaderRow}>
                                                            <TableCell size='small'>Business Unit</TableCell>
                                                            <TableCell size='small'>Email</TableCell>
                                                            <TableCell size='small'>Details</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell size='small'>PTRA</TableCell>
                                                            <TableCell size='small'>pepsilogistics@pepsico.com</TableCell>
                                                            <TableCell size='small'>The Traditional Team - We handle Dairy Farmers America Bottles, DFA orders, Frito Lay, Plant to Plant Transfers, Special Events, Projects, and R&D orders. Most orders require Cost Center, DIVLOC, PEPLOC or Account number depending on what location they are being shipped into.</TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell size='small'>PQGI</TableCell>
                                                            <TableCell size='small'>logistics_qginbound@pepsico.com</TableCell>
                                                            <TableCell size='small'>The Quaker and Gatorade Team. They handle ingredients for the plants to produce product for Quaker and Gatorade. This includes labels, bottles, corrugate, and seasoning that include salts and sugars.</TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell size='small'>PBCI</TableCell>
                                                            <TableCell size='small'>spapeplogisticspbc@pepsico.com</TableCell>
                                                            <TableCell size='small'>The Pepsi Bottle Company Team. This will include all COLD-Fill bottlers. This team handles orders for Pepsi plants to include - Cans, Lids, Preforms, Labels, Corrugate, Dunnage for the Pepsi plants, Rockstar plants, Dry Sugar, Shrink Wrap, Closures, BIB, Paperboard, Perm Merchandise, North American Coffee Partnership, Canadian Pepsi Bottlers.</TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Box>
                                    </Grid>
                                    <Grid size={12} textAlign={"center"}>
                                        <Typography sx={textStyle}>We'll review your request and grant access if everything is in -
                                            order</Typography>
                                    </Grid>
                                    <Grid size={12} textAlign={"center"}>
                                        <Button type="button" variant="contained" size="small" style={{ background: '#004F9A' }} onClick={navigateToSignIn}>Back to Signin</Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
                <Grid size={{ xs: 1, sm: 1, md: 2, lg: 2.5, xl: 3 }}></Grid>
            </Grid>
        </div>
    )
}

export default UserRegistration;